<template>
  <div class="list-item">
    <div v-for="(item, index) in list" :key="index" class="item">
      <div class="content">
        <img class="contentImg" @click="updata(item)" :src="item.cover_path" alt="" srcset="">
      </div>
      <span class="title">{{ item.title }}</span>
    </div>
    <!-- 无数据 -->
    <div v-if="list.length === 0" class="no-data">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import { getSafeVideoUrl } from "@/utils/urlValidator";

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  list() {
    return {};
  },
  methods: {
    updata(data) {
      // 在传递数据前验证attachment URL是否安全
      if (data && data.attachment) {
        data = {
          ...data,
          attachment: getSafeVideoUrl(data.attachment, '')
        };
      }
      
      // 直接传递对象，无需JSON.stringify
      this.$router.push({
        path: "/detailsList",
        query: {
          data: data,
        },
      });
    },
    jumpMore() {
      this.$router.push({ path: '/videoList' })
    },
    captureFrame(index) {
      const video = this.$refs['video' + index];
      video.currentTime = 1;
      video.addEventListener('seeked', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        try {
          const dataUrl = canvas.toDataURL('image/png');
          this.$set(this.list[index], 'posterDataUrl', dataUrl);
        } catch (error) {
          console.error('捕获视频帧时出错:', error);
          // 出错时不设置posterDataUrl，继续使用原有封面或默认图像
        }
      }, { once: true });
    }
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .item {
    width: calc(50% - 20px);
    height: 240px;
    font-size: 16px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    margin: 10px;

    .content {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .contentImg {
      display: block;
      width: 100%;
      height: 200px;
    }

    .video {
      width: 100%;
      height: 200px;
      object-fit: contain;
    }

    .title {
      width: 100%;
      height: 32px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 26px;
    }
  }

  .no-data {
    width: 100%;
    height: 42px;
    font-size: 16px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.more {
  width: 100%;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 28px;
    height: 15px;
    margin-left: 15px;
  }
}
</style>